import { FC } from 'react';

import Inklapbaar from '@/assets/icons/Inklapbaar';
import Uitklapbaar from '@/assets/icons/Uitklapbaar';

import styles from './LmmExpandChevrons.module.css';

type LmmExpandChevronsProps = {
  /** Whether the thing these chevrons control is currently open/expanded. */
  open: boolean;
};

/**
 * Small chevron-pair indicator: pointing inward (›‹) when open (click to collapse),
 * pointing outward (‹›) when closed (click to expand).
 */
const LmmExpandChevrons: FC<LmmExpandChevronsProps> = ({ open }) => {
  return <span className={styles.expandChevrons}>{open ? <Inklapbaar /> : <Uitklapbaar />}</span>;
};
export default LmmExpandChevrons;
